var map = {
	"./favicon.png": "99dd",
	"./images/100-receitas.png": "07ae",
	"./images/16_dicas_fundamentai_sCX81.png": "8c2a",
	"./images/1frasco.png": "0def",
	"./images/3frascos.png": "77c4",
	"./images/50-receitas.png": "c4cf",
	"./images/6frascos.png": "cc3e",
	"./images/anti-pirataria-1024x94.png": "8965",
	"./images/bg-black-big.jpg": "b231",
	"./images/bg-black.jpg": "cf17",
	"./images/bg-carbon-2.jpg": "7834",
	"./images/bg-carbon-5.jpg": "d141",
	"./images/bg-carbon-5.png": "396d",
	"./images/bg-carbon.jpeg": "0481",
	"./images/bg-carbon.jpg": "e40b",
	"./images/bg-whatsapp.jpg": "85ef",
	"./images/compra-segura-w.png": "ad9f",
	"./images/compra-segura.png": "7832",
	"./images/confiavel-01-1.png": "3ef6",
	"./images/confiavel-02-1.png": "62f6",
	"./images/confiavel-03-1.png": "a009",
	"./images/confiavel-04-1.png": "a68f",
	"./images/entrega-lurevita.png": "b6b9",
	"./images/formas-pagamento.png": "d2e1",
	"./images/icon1-1-1024x1024.png": "feb7",
	"./images/icon2-1-1024x1024.png": "cd47",
	"./images/icon3-1-1024x1024.png": "4a92",
	"./images/icon4-1-1024x1024.png": "9a4b",
	"./images/icon5-1-1024x1024.png": "77d0",
	"./images/icone0-1024x1024.png": "ca3a",
	"./images/logo-1.png": "6fd8",
	"./images/midia-boaforma-1024x1024.png": "6f14",
	"./images/midia-hojeemdia-1024x1024.png": "dd03",
	"./images/midia-maisvoce-1024x1024.png": "50a1",
	"./images/midia-r7-1024x1024.png": "89e5",
	"./images/natudrin-3-unidades-1024x1024.png": "79ac",
	"./images/natudrin-depoimento-1.jpg": "893f",
	"./images/natudrin-depoimento-2.jpg": "d416",
	"./images/natudrin-depoimento-3.jpg": "7246",
	"./images/natudrin-depoimento-4.jpg": "f052",
	"./images/natudrin-depoimento-5.jpg": "0b71",
	"./images/natudrin-depoimento-6.jpg": "cbf1",
	"./images/pote-aberto.png": "c920",
	"./images/produto-duo.png": "216f",
	"./images/resultado1.jpg": "0ca9",
	"./images/resultado2.jpg": "7613",
	"./images/resultado3.jpg": "1d02",
	"./images/resultado4.jpg": "8fa4",
	"./images/resultado5.jpg": "7807",
	"./images/resultado6.jpg": "6174",
	"./images/site-seguro.png": "77e0",
	"./logo.png": "cf05",
	"./styles/variables.scss": "8df1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";